import {
  USER_FETCHED,
  USERS_FETCHED,
  USER_DELETED,
  USER_CREATED,
} from 'constants/actions';

const initialState = {
  usersById: {},
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case USER_FETCHED:
    case USER_CREATED:
      return {
        ...state,
        usersById: [action.user].reduce(
          (memo, user) => {
            return {
              ...memo,
              [user.id]: { ...user },
            };
          },
          { ...state.usersById },
        ),
      };
    case USERS_FETCHED:
      return action.users.reduce(
        (memo, user) => {
          memo.usersById[user.id] = { ...user };
          return memo;
        },
        { ...state, usersById: { ...state.usersById } },
      );
    case USER_DELETED:
      return [action.userId].reduce(
        (memo, userId) => {
          delete memo.usersById[userId];
          return memo;
        },
        { ...state, usersById: { ...state.usersById } },
      );
    default:
      return state;
  }
}
